export default __webpack_public_path__ + "static/media/adv-2.cff5a6cc.jpg";